/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";

// To extend enum
// declare module "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName" {
//     export enum ResourcesGroupName {
//         GAME_GROUP = "gamegroup"
//     }
// }

// const temp = ResourcesGroupName as any;
// temp["GAME_GROUP"] = "gamegroup";

export class ThorGameAssets {


    public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static FREESPIN_BACKGROUND:string = "freespinBackground";
    public static REELS_FRAME:string = "reels/reelsFrame";
    public static REEL_BACKGROUNDS:string[] = ["reels/reel_a_top", "reels/reel_b_top", "reels/reel_c_top", "reels/reel_d_top", "reels/reel_e_top"];
    public static ICON_MORE_FREESPINS_ENABLED:string = "icons/Icon_FS";
    public static ICON_MORE_FREESPINS_DISABLED:string = "icons/Icon_FS_disabled";
    public static ICON_MULTIPLIER_X1_ENABLED:string = "icons/Icon_X1";
    public static ICON_MULTIPLIER_X1_DISABLED:string = "icons/Icon_X1_disabled";
    public static ICON_MULTIPLIER_X2:string = "icons/Icon_X2";
    public static ICON_MULTIPLIER_X3:string = "icons/Icon_X3";
    public static ICON_MULTIPLIER_X4:string = "icons/Icon_X4";
    public static ICON_RANDOM_WILDS_ENABLED:string = "icons/Icon_RW";
    public static ICON_RANDOM_WILDS_DISABLED:string = "icons/Icon_RW_disabled";
    public static ICON_REEL_OF_WILDS_ENABLED:string = "icons/Icon_WR";
    public static ICON_REEL_OF_WILDS_DISABLED:string = "icons/Icon_WR_disabled";

    public static FREE_SPIN_INTRO_OUTRO_BANNER:string = "splashScreens/banner";

    public static INTRO_BACKGROUND:string = "introBackground";
    public static INTRO_LOGO:string = "introLogo";
    public static INTRO_LOGO_TINY:string = "tinyLogo";
    public static INTRO_BANNER_ASGARD_SPINS:string = "AsgardSpins";
    public static INTRO_BANNER_HAMMER_TIME:string = "HammerTime";
    public static INTRO_BANNER_RUNE_RAZE:string = "RuneRaze";
    public static INTRO_THOR_FEATURE:string = "lightningBonus";
    public static BACKGROUND_FLAG:string = "BackgroundElements";

    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        return GameResources.getTextures(ThorGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("thorCountUp", "fonts/bitmapfonts/thorCountUp.fnt"),
                    new BitmapFontAsset("thorCountUpBlue", "fonts/bitmapfonts/thorCountUpBlue.fnt")
                ]
            },
            {
                name : "introHighQuality",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("mainBackground", "sheets/mainJpeg/mainBackground.jpg"),
                    new TextureAsset("introLogo", "sheets/intro/introLogo.png")
                ]
            },
            {
                name : "intro",
                assets : [
                    new TextureAsset("intro0", "sheets/intro/intro0.json")
                ]
            }
        ],


        main : [
            {
                name : "mainHighQuality",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("tinyLogo", "sheets/mainHighQuality/tinyLogo.png"),
                    new TextureAsset("freespinBackground", "sheets/mainJpeg/freespinBackground.jpg"),
                    new TextureAsset("M1/M1", "sheets/symbols/M1.png"),
                    new TextureAsset("M3/M3", "sheets/symbols/M3.png"),
                    new TextureAsset(ThorGameAssets.REELS_FRAME, "sheets/main/reelsFrame.png"),
                    new TextureAsset("mainHighQuality0", "sheets/mainHighQuality/mainHighQuality0.json")
                ]
            },
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json"),
                    new TextureAsset("main7", "sheets/main/main7.json")
                ],
                animations : {
                    "reelDust" : "Wheelstop/Dust_",
                    "reelDivider" : "ui/reelDividers/div",
                    "reelDividerNearWin" : "ui/reelDividers/div-attention",
                    "button" : "ui/gameTweakerButton/button",
                    "button-disabled" : "ui/gameTweakerButton/button-disabled",
                    "scatterEnergy" : "S_Meter/S_Sworl/S_Sworl_",
                    "winEnergy" : "Betlinetest0/Betlinetest_",
                    "mjolnirtimeAnimation" : "B/B_Anim_Base/B_Feature_Base_",
                    "mjolnirtimeLightningAnimation" : "B/B_Lightning/B_Feature_lightning_",
                    "iconFrameGlow" : "Icons/Icon_Frameglow/Icon Frameglow_",
                    "iconSelected" : "Icons/Icon_Selection/Icon_choice_",
                    "bigWinCoin0" : "BigWin/coinCopper/Bronze",
                    "bigWinCoin1" : "BigWin/coinSilver/Silver",
                    "bigWinCoin2" : "BigWin/coinGold/Gold",
                    "x2WinTot_00003" : "MultiplyWintotal/x2WinTot_00003",
                    "x3WinTot_00003" : "MultiplyWintotal/x3WinTot_00003",
                    "x4WinTot_00003" : "MultiplyWintotal/x4WinTot_00003",
                    "Boom/CountupBoom_00000" : "MultiplyWintotal/Boom/CountupBoom_00000",
                    "Boom/CountupBoom_00001" : "MultiplyWintotal/Boom/CountupBoom_00001",
                    "Boom/CountupBoom_00003" : "MultiplyWintotal/Boom/CountupBoom_00003",
                    "Boom/CountupBoom_00005" : "MultiplyWintotal/Boom/CountupBoom_00005",
                    "Boom/CountupBoom_00006" : "MultiplyWintotal/Boom/CountupBoom_00006",
                    "Boom/CountupBoom_00008" : "MultiplyWintotal/Boom/CountupBoom_00008",
                    "Boom/CountupBoom_00010" : "MultiplyWintotal/Boom/CountupBoom_00010",
                    "Boom/CountupBoom_00011" : "MultiplyWintotal/Boom/CountupBoom_00011",
                    "Boom/CountupBoom_00013" : "MultiplyWintotal/Boom/CountupBoom_00013",
                    "Boom/CountupBoom_00014" : "MultiplyWintotal/Boom/CountupBoom_00014",
                    "Boom/CountupBoom_00016" : "MultiplyWintotal/Boom/CountupBoom_00016",
                    "Boom/CountupBoom_00017" : "MultiplyWintotal/Boom/CountupBoom_00017",
                    "Boom/CountupBoom_00018" : "MultiplyWintotal/Boom/CountupBoom_00018",
                    "Boom/CountupBoom_00019" : "MultiplyWintotal/Boom/CountupBoom_00019",
                    "Boom/CountupBoom_00020" : "MultiplyWintotal/Boom/CountupBoom_00020",
                    "Boom/CountupBoom_00021" : "MultiplyWintotal/Boom/CountupBoom_00021",
                    "Boom/CountupBoom_00022" : "MultiplyWintotal/Boom/CountupBoom_00022",
                    "Boom/CountupBoom_00023" : "MultiplyWintotal/Boom/CountupBoom_00023",
                    "Boom/CountupBoom_00024" : "MultiplyWintotal/Boom/CountupBoom_00024",
                    "Boom/CountupBoom_00025" : "MultiplyWintotal/Boom/CountupBoom_00025",
                    "Boom/CountupBoom_00026" : "MultiplyWintotal/Boom/CountupBoom_00026",
                    "Boom/CountupBoom_00028" : "MultiplyWintotal/Boom/CountupBoom_00028",
                    "Boom/CountupBoom_00029" : "MultiplyWintotal/Boom/CountupBoom_00029",
                    "Slash/GlowSlash_00000" : "MultiplyWintotal/Slash/GlowSlash_00000",
                    "Slash/GlowSlash_00001" : "MultiplyWintotal/Slash/GlowSlash_00001",
                    "Slash/GlowSlash_00002" : "MultiplyWintotal/Slash/GlowSlash_00002",
                    "Slash/GlowSlash_00003" : "MultiplyWintotal/Slash/GlowSlash_00003",
                    "Slash/GlowSlash_00004" : "MultiplyWintotal/Slash/GlowSlash_00004",
                    "Slash/GlowSlash_00005" : "MultiplyWintotal/Slash/GlowSlash_00005",
                    "Slash/GlowSlash_00006" : "MultiplyWintotal/Slash/GlowSlash_00006",
                    "Slash/GlowSlash_00007" : "MultiplyWintotal/Slash/GlowSlash_00007",
                    "Slash/GlowSlash_00008" : "MultiplyWintotal/Slash/GlowSlash_00008",
                    "Slash/GlowSlash_00009" : "MultiplyWintotal/Slash/GlowSlash_00009",
                    "Slash/GlowSlash_00010" : "MultiplyWintotal/Slash/GlowSlash_00010",
                    "Slash/GlowSlash_00011" : "MultiplyWintotal/Slash/GlowSlash_00011",
                    "Slash/GlowSlash_00012" : "MultiplyWintotal/Slash/GlowSlash_00012",
                    "Slash/GlowSlash_00013" : "MultiplyWintotal/Slash/GlowSlash_00013"
                }
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("FSWonSpine", "Spine/AsgardSpins.json"),//Freespins
                    new SpineAsset("hammerRaze", "Spine/HammerRaze.json"),
                    new SpineAsset("runeRaze", "Spine/RuneRaze.json"),
                    new SpineAsset("multiplyWinTotalSpine", "Spine/MultiplyTotWin.json"),//WinTot, Skins: 2, 3, 4
                    new SpineAsset("bigWinSpine", "Spine/BigWin.json"),//
                    new SpineAsset("scatterMeterSpine", "Spine/ScatterMeter.json"),//M_FillTwo, AnticipationThrd, MoreSpins, SpinsFade
                    new SpineAsset("chainCD", "Spine/ChainCD.json"),
                    new SpineAsset("chainRemove", "Spine/ChainRemove.json"),
                    new SpineAsset("lightningRandom", "Spine/LightningRandom.json"),
                    new SpineAsset("lightningReel", "Spine/LightningReel.json"),
                    new SpineAsset("scatterReel", "Spine/ScatterReel.json"),
                    new SpineAsset("thorReel", "Spine/ThorReel.json")
                ]
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbols1", "sheets/symbols/symbols1.json"),
                    new TextureAsset("symbols2", "sheets/symbols/symbols2.json"),
                    new TextureAsset("symbols3", "sheets/symbols/symbols3.json")
                ],
                animations : {
                    L1_initialWin : "L1/L1_InitialWin/L1_InitialWin_",
                    L2_initialWin : "L2/L2_InitialWin/L2_InitialWin_",
                    L3_initialWin : "L3/L3_InitialWin/L3_InitialWin_",
                    L4_initialWin : "L4/L4_InitialWin/L4_InitialWin_",
                    L5_initialWin : "L5/L5_InitialWin/L5_InitialWin_",
                    M1_initialWin : "M1/M1_InitialWin/M1_InitialWin_",
                    M2_initialWin : "M2/M2_InitialWin/M2_InitialWin_",
                    M3_initialWin : "M3/M3_InitialWin/M3_InitialWin_",
                    M4_initialWin : "M4/M4_InitialWin/M4_InitialWin_",
                    M5_initialWin : "M5/M5_InitialWin/M5_InitialWin_",
                    W_initialWin : "W/Wild_InitialWin/Wild_InitialWin_",
                    B_initialWin : "B/B_win",
                    S_initialWin : "S/S_win",
                    L1_win : "L1/L1_win",
                    L2_win : "L2/L2_win",
                    L3_win : "L3/L3_win",
                    L4_win : "L4/L4_win",
                    L5_win : "L5/L5_win",
                    M1_win : "M1/M1_win",
                    M2_win : "M2/M2_win",
                    M3_win : "M3/M3_win",
                    M4_win : "M4/M4_win",
                    M5_win : "M5/M5_win",
                    W_win : "W/W_win",
                    B_win : "B/B_win",
                    S_win : "S/S_win",
                    W_sticky : "W/W_stickyDark",
                    W_chains : "W/W_chains",
                    S_land_1 : "S/S_Land/Attention_",
                    S_idleScatter_1 : "S/1_idle/S_Idle1_",
                    S_attention : "S/more_attention/attention_more_",
                    S_idleScatter_2 : "S/more_Idle/S_Idle2_",
                    S_nudgeOut : "S/S_NudgeOut/NudgeOut_Break_",
                    S_nudgeOutReversed : "S/S_NudgeOutReversed/NudgeOut_Break_",
                    M1_spinGlow : "M1/M1_spinGlow",
                    L1_spinGlow : "L1/L1_spinGlow",
                    L2_spinGlow : "L2/L2_spinGlow",
                    L3_spinGlow : "L3/L3_spinGlow",
                    L4_spinGlow : "L4/L4_spinGlow",
                    L5_spinGlow : "L5/L5_spinGlow",
                    M1_lit : "M1/M1_lit",
                    L1_lit : "L1/L1_lit",
                    L2_lit : "L2/L2_lit",
                    L3_lit : "L3/L3_lit",
                    L4_lit : "L4/L4_lit",
                    L5_lit : "L5/L5_lit"
                }
            }
        ]
    };
}